import actions from '../../../features/companies/document_templates/variables';

window.Bizneo.variables_controller = {
  index() {
    actions();
  },
};
